import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import HeaderNavbar from "../Component/Navbar";
import Footer from "../Component/Footer";

export default function Terms() {
  return (
    <>
      <HeaderNavbar />

      {/* PAGE HEADER */}
      <div
        style={{
          background: "#f8f5f2",
          padding: "60px 0",
          textAlign: "center",
        }}
      >
        <h1 style={{ color: "#7b1e3b", fontWeight: "600" }}>
          Terms of Service
        </h1>
        <p className="text-muted mt-3">
          Please read these Terms of Service carefully before using our
          platform.
        </p>
      </div>

      {/* TERMS SECTION */}
      <Container style={{ padding: "70px 10px" }}>
        <Row>
          <Col lg={12}>
            <h3 className="mb-3">1. Acceptance of Terms</h3>
            <p>
              Welcome to <b>KVL Matrimony ("Platform") available through the website https://kvlmatrimony.com</b>.<br />
              By registering, accessing, subscribing to or using the Platform, you acknowledge that you have read, understood and agree to be bound by this Terms of Use & Membership Agreement and all other policies published by KVL Matrimony.
              If you do not agree to these Terms, you must discontinue use of the Platform.

            </p>
            <h3 className="mt-5 mb-3">2. About the Platform</h3>
            <p>KVL Matrimony is an online matrimonial platform exclusively intended to facilitate matrimonial introductions within the <b>Veerashaiva Lingayat community</b>.<br />
              The Platform acts only as an intermediary to connect members and does not participate in or guarantee any matrimonial alliance.
            </p>
            <h3 className="mt-5 mb-3">3. Eligibility</h3>
            <p>To register and use the Platform, you must:</p>
            <ul>
              <li>Be at least 18 years of age (women) and 21 years of age (men) or such age as prescribed by applicable law.</li>
              <li>Be legally competent to enter into a binding contract.</li>
              <li>Register only for lawful matrimonial purposes.</li>
              <li>Provide complete, accurate and truthful information.</li>
              <li>Maintain only one active account unless expressly permitted.</li>
            </ul>
            <p>KVL Matrimony reserves the right to refuse or terminate any registration that does not meet these requirements.</p>

            <h3 className="mt-5 mb-3">4. Registration & User Account</h3>
            <p>Users are responsible for:</p>
            <ul>
              <li>Providing accurate information.</li>
              <li>Keeping profile information updated.</li>
              <li>Maintaining the confidentiality of login credentials.</li>
              <li>All activities carried out through their account.</li>
            </ul>
            <p>You shall immediately notify the Platform of any unauthorized access or security breach.</p>

            <h3 className="mt-5 mb-3">5. User Profile</h3>
            <p>
              The information, photographs and documents submitted by you shall:<br />
              •	Be genuine and lawful.<br />
              •	Belong to you or be uploaded with proper authorization.<br />
              •	Not violate any intellectual property or privacy rights.<br />
              •	Not contain false, misleading, offensive, defamatory or obscene content.<br />
              KVL Matrimony may review, edit, suspend or remove any profile at its sole discretion.

            </p>

            <h3 className="mt-5 mb-3">6. Membership & Subscription</h3>
            <p>
              The Platform offers multiple Premium Membership plans.
              Premium services are available only upon payment of applicable subscription charges.
              Membership benefits, validity, pricing and renewal shall be governed by the Subscription, Billing, Refund & Service Policy.

            </p>

            <h3 className="mt-5 mb-3">7. Payments</h3>
            <p>
              Subscription fees shall be payable in advance.<br />
              All payments made are subject to applicable taxes.<br />
              Payments are processed through authorized third-party payment service providers.<br />
              Refunds, cancellations and renewals shall be governed by the Subscription Policy.

            </p>

            <h3 className="mt-5 mb-3">8. User Responsibilities</h3>
            <p>
              Every member agrees to:<br />
              •	Use the Platform only for genuine matrimonial purposes.<br />
              •	Respect the privacy of other members.<br />
              •	Conduct independent verification before making personal or matrimonial decisions.<br />
              •	Communicate respectfully.<br />
              •	Comply with all applicable laws.<br />
              Users remain solely responsible for their interactions both online and offline.

            </p>

            <h3 className="mt-5 mb-3">9. Prohibited Activities</h3>
            <p>Users shall not:<br />
              •	Create fake or duplicate profiles.<br />
              •	Misrepresent identity or marital status.<br />
              •	Upload false or misleading information.<br />
              •	Harass, threaten, stalk or abuse other users.<br />
              •	Publish offensive, defamatory, hateful or unlawful content.<br />
              •	Solicit money or engage in financial fraud.<br />
              •	Promote commercial products or services.<br />
              •	Attempt unauthorized access to the Platform.<br />
              •	Copy, scrape, reverse engineer or interfere with the Platform.<br />
              •	Upload malware or malicious software.<br />
              •	Use automated tools, bots or scripts without authorization.<br />
              Violation of these Terms may result in immediate suspension or permanent termination.
            </p>
            <h3 className="mt-5 mb-3">10. Profile Verification</h3>
            <p>
              KVL Matrimony may offer profile verification based on documents or other information provided by users.<br />
              Verification is conducted only to improve platform reliability and shall not be construed as a guarantee of identity, character, background, financial status or matrimonial suitability.<br />
              Users must exercise independent judgment before proceeding with any relationship.

            </p>

            <h3 className="mt-5 mb-3">11. Communication</h3>
            <p>
              The Platform may communicate with users through:<br />
              •	Email<br />
              •	SMS<br />
              •	Phone Calls<br />
              •	WhatsApp<br />
              •	Push Notifications<br />
              •	In-app Messages (pop-up)<br />
              Such communications may include account notifications, subscription updates, security alerts, customer support and service-related information.<br />
              Users may manage non-essential communication preferences where available.

            </p>

            <h3 className="mt-5 mb-3">12. Privacy & Data Protection</h3>
            <p>
              Collection, use, storage, processing and sharing of personal information shall be governed by the Privacy, Data Processing & DPDP Compliance Policy.<br />
              By using the Platform, you consent to such processing in accordance with applicable law.

            </p>

            <h3 className="mt-5 mb-3">13. Community Standards</h3>
            <p>
              All members are expected to maintain respectful behaviour and comply with the Community Standards, Safety & Platform Usage Policy.<br />
              KVL Matrimony reserves the right to moderate content and take appropriate action against policy violations.

            </p>

            <h3 className="mt-5 mb-3">14. Intellectual Property</h3>
            <p>
              All content, software, trademarks, logos, designs, databases, text, graphics and other intellectual property associated with KVL Matrimony remain the exclusive property of the Platform or its licensors.<br />
              No content may be copied, reproduced, distributed, modified or commercially exploited without prior written permission.

            </p>

            <h3 className="mt-5 mb-3>">15. Third-Party Services</h3>
            <p>The Platform may integrate third-party services including payment gateways, SMS providers, email services, cloud hosting, verification services and communication platforms.<br />
              KVL Matrimony is not responsible for the availability, performance or policies of such third-party services.
            </p>

            <h3 className="mt-5 mb-3>">16. No Guarantee</h3>
            <p>KVL Matrimony provides only an online platform for matrimonial introductions.<br />
              The Platform does not guarantee:<br />
              •	Profile authenticity beyond reasonable verification.<br />
              •	Compatibility between members.<br />
              •	Successful communication.<br />
              •	Engagement.<br />
              •	Marriage.<br />
              •	Marital compatibility.<br />
              •	Continued availability of any member.<br />
              Users make all matrimonial decisions at their own discretion.

            </p>

            <h3 className="mt-5 mb-3>">17. Suspension & Termination</h3>
            <p>KVL Matrimony may suspend or terminate any account without prior notice if:<br />
              •	These Terms are violated.<br />
              •	False information is provided.<br />
              •	Fraudulent or unlawful activity is suspected.<br />
              •	User conduct adversely affects the Platform or other members.<br />
              Termination shall not affect accrued rights or outstanding payment obligations.


            </p>

            <h3 className="mt-5 mb-3>">18. Disclaimer</h3>
            <p>The Platform is provided on an "as available" and "as is" basis.<br />
              While reasonable efforts are made to maintain service quality, KVL Matrimony does not warrant uninterrupted availability, error-free operation or complete accuracy of user-generated information.

            </p>

            <h3 className="mt-5 mb-3>">19. Limitation of Liability</h3>
            <p>To the maximum extent permitted by law, KVL Matrimony shall not be liable for:<br />
              •	Decisions taken by users.<br />
              •	Meetings or communications between members.<br />
              •	Matrimonial outcomes.<br />
              •	Financial loss.<br />
              •	Emotional distress.<br />
              •	Identity fraud committed by users.<br />
              •	Service interruptions beyond reasonable control.<br />
              The total liability of KVL Matrimony, if any, shall not exceed the subscription fees paid by the user during the twelve (12) months immediately preceding the event giving rise to the claim.

            </p>

            <h3 className="mt-5 mb-3>">20. Indemnity</h3>
            <p>Users agree to indemnify and hold harmless KVL Matrimony, its owners, employees, affiliates and service providers against any claims, losses, liabilities, damages or expenses arising from:<br />
              •	Breach of these Terms.<br />
              •	Violation of applicable laws.<br />
              •	Misuse of the Platform.<br />
              •	Infringement of third-party rights.

            </p>

            <h3 className="mt-5 mb-3>">21. Governing Law & Jurisdiction</h3>
            <p>These Terms shall be governed by the laws of India.
              Any dispute arising out of or relating to the Platform shall be subject to the exclusive jurisdiction of the competent courts at Bengaluru, Karnataka.

            </p>

            <h3 className="mt-5 mb-3>">22. Amendments</h3>
            <p>KVL Matrimony may modify these Terms from time to time.<br />
              Updated versions shall become effective upon publication on the Platform.
              Continued use of the Platform constitutes acceptance of the revised Terms.


            </p>

            <h3 className="mt-5 mb-3>">23. Contact & Grievance</h3>
            <p>For queries, complaints or legal notices, users may contact the Grievance Officer through the contact details published on the Platform.<br />
              Grievances shall be addressed in accordance with applicable laws and the Grievance Redressal Policy.
            </p>

            <h3 className="mt-5 mb-3>">24. User Declaration</h3>
            <p>By registering or using KVL Matrimony, you confirm that:<br />
              •	You have read and understood this Agreement.<br />
              •	The information provided by you is true and accurate.<br />
              •	You will use the Platform only for lawful matrimonial purposes.<br />
              •	You agree to comply with all applicable laws.<br />
              •	You consent to the processing of your personal data in accordance with the Privacy, Data Processing & DPDP Compliance Policy.<br />
              •	You agree to abide by all policies published by KVL Matrimony, as amended from time to time.



            </p>


            <p className="mt-5 text-muted">
              <strong>Last Updated:</strong>5th, July 2026
            </p>
          </Col>
        </Row>
      </Container>

      <Footer />
    </>
  );
}